import React, { useEffect } from "react";
import Categories from "../components/categories/Categories";
import ContactForm from "../components/email/Contactform.js";
import FastDeliveryCard from "../components/fastDeliveryCard/FastDeliveryCard";
import LatestDiscountCouponCode from "../components/latestDiscountCouponCode/LatestDiscountCouponCode";
import PopularProduct from "../components/popularProduct/PopularProduct";
import OrganicProductCard from "../components/organicProductCard/OrganicProductCard.js";
import Slider from "../components/slider/Slider";
import LatestDiscountedProduct from "../components/latestDiscountedProduct/LatestDiscountedProduct";
import { Coupon } from "../fakeData/coupon";
import ExportCountries from "../components/exportCountries/ExportCountries";
import Experience from "../components/experience/Experience";


function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
const twoCupon=Coupon.slice(0,2)
  return (
    <div className="bg-gray-50">
      <div className="min-h-screen">
        <div className="bg-white">
          <div className="mx-auto py-5 max-w-screen-2xl px-3 sm:px-10">
            <div className="flex w-full">
              <div className=" flex-shrink-0 xl:pr-2 lg:block w-full lg:w-5/5">
                <Slider />
              </div>
            </div>
            {/* <OrganicProductCard /> */}
          </div>
        </div>

        <Categories />
        <ExportCountries />
        <Experience />
        <ContactForm/>
        {/* <PopularProduct /> */}
        {/* <FastDeliveryCard /> */}
        {/* <LatestDiscountedProduct /> */}
      </div>
    </div>
  );
}

export default Home;
